import {
  
  getMenuByRouter
  
} from '@/utils'
import routers from '@/router/routers'

export default {
  namespaced: 'app', //具名引用时使用
  state: {

  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    errorCount: state => state.errorList.length
  },
  actions: {              // actions提交mutations

  },
  modules: {  //子模块，一般在主模块中用到
  
  }
}
